<div class="radio-button-container display-flex flex-column">
  <label [ngClass]="[labelCss, labelRequired ? 'label-required' : '']" *ngIf="label">{{ label }}</label>
  <div class="radio-button-container-wrapper" [ngClass]="{ 'marked-as-invalid': markAsInvalid }">
    <mat-radio-group [formControl]="control" [ngClass]="radioGroupClass" (change)="onChanged($event.value)">
      <mat-radio-button *ngFor="let item of items" [value]="item.value" class="radio-option">
        <span class="radio-option-container display-flex align-items-center grid-gap-4">
          <span [ngClass]="optionCss" [innerHTML]="item.label | escapeHtml"></span>
          <button
            *ngIf="shouldShowClear(item.value)"
            type="button"
            class="action-button small-mat-icon-button small-mat-icon-button-increased"
            mat-icon-button
            [matTooltip]="clearTooltip"
            (click)="onResetClick($event)">
            <app-icon
              [iconWidth]="16"
              [iconHeight]="16"
              [svg]="EIcon.DO_NOT_DISTURB"
              [iconColor]="EColorPalette.cRed3"></app-icon>
          </button>
        </span>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <app-input-error
    *ngIf="errorSection && errors"
    [errors]="errors"
    [visible]="markAsInvalid || (errors && showValidationError)"></app-input-error>
</div>
